import { useMemo } from 'react';
import isEqual from 'lodash/isEqual';
import { slice as historySlice } from 'state/journey-routes/journey-routes-slice';
import { slice as settingsSlice } from 'state/settings/settings-slice';
import { slice as analyticsSlice } from 'state/analytics/analytics-slice';

import { initialState } from 'state/allSlices';
import { store } from 'state/store';

export const useInitialState = () => {
  const currentState = store.getState();

  const excludeSlices = (excludeSlices) => {
    const currentStateCopy = { ...currentState };
    const initialStateCopy = { ...initialState };

    excludeSlices.forEach((sliceName) => {
      delete currentStateCopy[sliceName];
      delete initialStateCopy[sliceName];
    });

    return [currentStateCopy, initialStateCopy];
  };

  const hasStateInitialValue = isEqual(
    ...excludeSlices([
      // delete analytics slice before compare as experiment values are updated outside of journey flow by AdobeTargetProvider
      analyticsSlice.name,
      // delete settings slice before compare as this is updated outside of journey flow by AppConfigProvider
      settingsSlice.name,
      // delete history slice before compare as this always contains initial landing path
      historySlice.name
    ])
  );

  return useMemo(() => ({ hasStateInitialValue }), [hasStateInitialValue]);
};
